import { createContext, useContext, type PropsWithChildren } from 'react';
import { defaultConfig, type BrandConfig } from './util/brand-configs';

const BrandConfigContext = createContext<BrandConfig | null>(null);

type BrandConfigProviderProps = PropsWithChildren<{
  brandConfig: BrandConfig;
}>;

export function BrandConfigProvider({ children, brandConfig }: BrandConfigProviderProps) {
  return <BrandConfigContext.Provider value={brandConfig}>{children}</BrandConfigContext.Provider>;
}

const disabledSurfaceConfig = {
  ...defaultConfig,
  surfaceConfig: {
    ...defaultConfig.surfaceConfig,
    isEnabled: false,
  },
} as const satisfies BrandConfig;

export function useBrandConfig(): BrandConfig {
  const context = useContext(BrandConfigContext);

  // If an app has not opted into the BrandConfigProvider, disable surfaces.
  if (!context) {
    return disabledSurfaceConfig;
  }

  return context;
}
